<template lang="pug">
  v-container(class="pa-15")
      h2 Habilitar/Deshablitar permisos de referidos a los clientes
      v-row(align="center" justify="center")
        v-text-field(label="Email" required type="text" v-model="email")
        v-btn(class="ml-2" color='primary' :disabled="(email === '' ? true : false) || loading" @click="searchUser") buscar cliente
      v-progress-linear(v-if="loading" indeterminate="" color="primary")
      v-row(align="center" justify="center")
        h3 {{name + ' ' + last_name}}
        v-btn(class="ml-2" color='primary' :disabled="(email === '' ? true : false) || loading" @click="enableDisableClient") {{canHaveReferrals ? 'Deshabilitar' : 'Habilitar'}}
      v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
          | {{ snackbar.text }}
          v-btn(dark='' text='' @click='snackbar.snackbar = false')
            | {{$t('payment.general.close')}}
</template>

<script>
  import ReferralsCard from '@/components/custom/ReferralsCard'

  export default {
    components: {
      ReferralsCard: ReferralsCard,
    },
    data () {
      return {
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 10000,
        },
        loading: false,
        email: '',
        name: '',
        last_name: '',
        uid: '',
        canHaveReferrals: false,
      }
    },
    methods: {
      searchUser () {
        this.loading = true
        this.$store.dispatch('referrals/getUserByEmail', this.email).then(res => {
          // console.log(res)
          this.loading = false
          if (res) {
            this.name = res.profile.name
            this.last_name = res.profile.last_name
            this.canHaveReferrals = res.profile.canHaveReferrals
            this.uid = res.uid
          } else {
            this.setDataNotification(true, 'red', 'Usuario no encontrado')
          }
        })
      },
      enableDisableClient () {
        this.loading = true
        let permission
        if (this.canHaveReferrals) { // puede venir nulo o undefined
          this.canHaveReferrals = false
          permission = false
        } else {
          this.canHaveReferrals = true
          permission = true
        }
        const data = {
          permission: permission,
          userId: this.uid,
        }
        this.$store.dispatch('referrals/enableDisableClient', data).then(res => {
          // console.log(res)
          this.loading = false
        })
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
    },
  }
</script>
